/**
 * @namespace SearchSuggestion
 * @aka SWR.SearchSuggestion
 */
SWR.SearchSuggestion = (function ($) {

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'searchSuggestion';
  var DATA_KEY = 'swr.' + NAME;
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];

  var Event = {
    PJAX_DATA_API: 'pjax:end' + EVENT_KEY + DATA_API_KEY
  };

  var Selector = {
    DATA_SPY: '#header .navbar-search,.form-suche'
  };

  var controller;

  /*
   TODO: private helpers go here.
   */

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */
  var SearchSuggestion = function () {

    function SearchSuggestion(element) {
      var self = this;

      // protected
      self.element = element;
      self.$element = $(self.element);
      self.suggestUrl = self.$element.data('suggestUrl'); //TODO: Entfernen nach Umschalten auf neue Suche
      self.isOldSearch = 'undefined' !== typeof self.suggestUrl;
      self.elasticCloudSearchSuggestUrl = self.$element.data('elasticCloudSearchSuggestUrl'); //Für neue Suche
      self.isARDElastic = 'undefined' !== typeof self.elasticCloudSearchSuggestUrl;
      self.$input = self.$element.find('[name="q"]');

      if (0 === self.$input.length) {
        self.$input = self.$element.find('[name="swx_q"]');
      }
      self.isHeader = self.$element.hasClass('navbar-search');

      //Testdaten:
      self.testJSON = {
        "query": "pop",
        "results": [
          {
            "name": "pop night",
            "type": "suggest"
          },
          {
            "name": "popup",
            "type": "suggest"
          },
          {
            "name": "popnacht",
            "type": "suggest"
          },
          {
            "name": "popup mit daniela hilpp",
            "type": "suggest"
          },
          {
            "name": "popcorn",
            "type": "suggest"
          },
          {
            "name": "popolski",
            "type": "suggest"
          },
          {
            "name": "popshop",
            "type": "suggest"
          },
          {
            "name": "popup mit daniele hilpp",
            "type": "suggest"
          },
          {
            "name": "popnacht 13.4.2021 mit ben streubel",
            "type": "suggest"
          },
          {
            "name": "pop up daniela hilpp",
            "type": "suggest"
          }
        ]
      };

      if (!self.isARDElastic) {
        if (!self.isOldSearch) {
          //Wenn es keine SuggestURL gibt, wird abgebrochen.
          return;
        }
      }

      //Suggestion
      self._suggestion();
    }

    SearchSuggestion.prototype._suggestion = function _suggestion() {
      var self = this;
      var _autocompleteSuggestConfig = {};


      if (self.isARDElastic) {
        /**Neue Suche**/

        _autocompleteSuggestConfig = {
          minChars: 2,
          delay: 150,
          source: function (term, suggest) {
            // cancel pending request if any
            if (controller) {
              controller.abort();
            }

            // make our request cancellable
            controller = new AbortController();
            var signal = controller.signal;

            /*
             * Fetch API
             * @see https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API
             */

            var requestHeaders = new Headers();
            requestHeaders.append('Accept', 'application/json, */*; q=0.01');
            requestHeaders.append('Content-Type', 'application/json; charset=UTF-8');
            requestHeaders.append('Authorization', 'Bearer ' + process.env.ARD_SEARCH_SUGGEST_TOKEN);

            fetch(self.elasticCloudSearchSuggestUrl, {
              headers: requestHeaders,
              method: "POST",
              signal: signal,
              body: JSON.stringify({
                "query": term.toLowerCase(),
                "types": {
                  "documents": {
                    "fields": [
                      "meta_description"
                    ]
                  }
                },
                "size": 10
              })
            }).then(function (response) {
              controller = null;
              return response.json();
            }).then(function (data) {
              var matches = [];
              if (!data.hasOwnProperty('results') || !data.results.hasOwnProperty('documents') || !Array.isArray(data.results.documents)) {
                return;
              }
              matches = data.results.documents.map(function (result) {
                return result.suggestion
              });

              suggest(matches);
            }).catch(function (exception) {
              if ('AbortError' === exception.name) {
                console.debug('Fetch aborted');
                return;
              }
              (console.error || console.log).call(console, exception.stack || exception)
            });
          },
          renderItem: function (item, search) {
            search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
            var re = new RegExp("(" + search.split(' ').join('|') + ")", "gi");
            return '<div class="autocomplete-suggestion" data-val="' + item + '">' + item.replace(re, "<strong>$1</strong>") + '</div>';
          },
          onSelect: function (event, term, item, input) {
            // submit on select
            if (input) {
              if (!window.isFractal) {
                input.closest('form').find('button[type="submit"]').trigger('click');
              } else {
                console.log("Submitted:", input.val());
              }

              if (event.which !== 13 && event.keyCode !== 13) {
                return;
              }

              event.preventDefault();
              event.stopPropagation();
              event.stopImmediatePropagation();
            }
          }
        };
      } else {
        //TODO: Nach Umschalten der neuen Suche kann dieser Zweig entfernt werden!!!!!
        var xhr;
        var url = 'https://www.swr.de';

        _autocompleteSuggestConfig = {
          minChars: 2,
          delay: 0,
          source: function (term, suggest) {
            try {
              xhr.abort();
            } catch (e) {
            }

            term = term.toLowerCase();

            if (!window.isFractal || window.location.host.indexOf('localhost') === -1) {
              url = window.location.origin;
            }

            if (url.indexOf('beta') !== -1) {
              url = url.split('.');
              url[0] = 'https://www';
              url = url.join('.');
            }

            console.log(url + self.suggestUrl + encodeURIComponent(term));
            xhr = $.getJSON(url + self.suggestUrl + encodeURIComponent(term), function (data) {
              var matches;
              if ('object' === typeof data && data.hasOwnProperty('results')) {
                // format = rich
                matches = $.map(data.results, function (result) {
                  return result.name
                });
              } else {
                // format = legacy
                matches = data;
              }

              suggest(matches);
            });
          },
          renderItem: function (item, search) {
            search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
            var re = new RegExp("(" + search.split(' ').join('|') + ")", "gi");
            return '<div class="autocomplete-suggestion" data-val="' + item + '">' + item.replace(re, "<strong>$1</strong>") + '</div>';
          },
          onSelect: function (event, term, item, input) {
            // submit on select
            if (input) {
              if (!window.isFractal) {
                input.closest('form').find('button[type="submit"]').trigger('click');
              } else {
                console.log("Submitted:", input.val());
              }

              if (event.which !== 13 && event.keyCode !== 13) {
                return;
              }

              event.preventDefault();
              event.stopPropagation();
              event.stopImmediatePropagation();
            }
          }
        };
      }

      var _initSuggest = function _initSuggest($element, destroyIt) {
        var className = '';

        if (self.isHeader) {
          className = 'swr-autocomplete-header';
        } else {
          className = 'swr-autocomplete-suchseite';
        }

        self.$input.attr('data-class-name-suggestion', className);

        $element.autoComplete(_autocompleteSuggestConfig);

        if (destroyIt) {
          $(document).one('pjax:beforeSend', function () {
            $element.autoComplete('destroy');
          });
        }
      };

      if (self.isHeader) {
        _initSuggest(self.$input, false);
      } else {
        _initSuggest(self.$input, true);
      }
    };


    // public
    SearchSuggestion.prototype.dispose = function dispose() {
      this.$element.off(EVENT_KEY);

      this.$element.find('.close-btn').remove();

      this.$element = null;
      this.element = null;

      $(document).off(EVENT_KEY);
    };

    // static
    SearchSuggestion._jQueryInterface = function _jQueryInterface() {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);

        if (!data) {
          data = new SearchSuggestion(this);
          $(this).data(DATA_KEY, data);
        }
      });
    };

    return SearchSuggestion;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */

  $(Selector.DATA_SPY).each(function () {
    var $element = $(this);
    SearchSuggestion._jQueryInterface.call($element, $element.data());
  });

  //Alle Suggestion-Listen bekommen eine zusätzliche Klasse
  $('[data-class-name-suggestion]').each(function (index, item) {
    $($('.autocomplete-suggestions')[index]).addClass($(item).data('classNameSuggestion'));
  });

  $(document).on(Event.PJAX_DATA_API, function (event, xhr, options) {
    $(options.container).find(Selector.DATA_SPY).each(function () {
      var $element = $(this);
      SearchSuggestion._jQueryInterface.call($element, $element.data());
    });

    //Alle Suggestion-Listen bekommen eine zusätzliche Klasse
    $('[data-class-name-suggestion]').each(function (index, item) {
      $($('.autocomplete-suggestions')[index]).addClass($(item).data('classNameSuggestion'));
    });
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */
  $.fn[NAME] = SearchSuggestion._jQueryInterface;
  $.fn[NAME].Constructor = SearchSuggestion;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return SearchSuggestion._jQueryInterface;
  };

  return SearchSuggestion;

})(window.jQuery);










